import React, { Component } from 'react';
import { Modal, Button, message } from 'antd';
import UnconfrimManhourSummary from './Widget';
import ExportUtil from '../../../common/ExportUtil';
import { convertOption } from '../../shared/selectFn';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import TableC from '../../basicElement/TableC';
import format from '../../shared/format';
import Filter from './Filter';
import SideNav from '../SideNav';
import moment from 'moment';

const monthFormat = 'YYYY-MM';

class UnconfirmProManhour extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: false,
            searchParams: {},
            curParams: {},
            pagination: {
                pageSize: 10,
                current: 1,
            },
            stageOption: [],
            businessList: [],
            maxMonth: null,
        };
    }

    componentDidMount() {
        this.queryTypeConfigureList();
        this.queryEffectiveDate();
        this.queryWithLevelByParams();
    }

    queryEffectiveDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            Fetch.post( API_URL.home.queryEffectiveDate)
                .then(cb)
                .catch(err => {
                    console.error(err);
                });
        }, res => {
            const { date: trueDate, trueYear, trueMonth } = res;
            const { searchParams } = this.state;
            let date = format('month', trueYear, trueMonth);
            if (moment(trueDate).date() <= 25) {
                date = moment(trueDate).subtract(1, 'M').format(monthFormat);
            }
            searchParams.begin = date;
            searchParams.end = date;
            this.setState({
                maxMonth: date,
                searchParams,
                curParams: {...searchParams},
            }, () => {
                this.loadData();
            });
        });
    }

    queryTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            Fetch.post(API_URL.common.typeConfigureList)
                .then(cb)
                .catch(err => {
                    console.error(err);
                });
        }, res => {
            const { stageList } = res;
            const stageOption = (stageList || []).map(convertOption('typeConfigureId', 'typeValue'));
            this.setState({ stageOption });
        });
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            Fetch.post(API_URL.common.queryWithLevelByParams, { typeName: 'LINE_OF_BUSINESS' })
                .then(cb)
                .catch(err => {
                    console.error(err);
                });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    loadData = () => {
        const { curParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const { stageIds } = curParams;
        const params = this.splitParams(curParams);

        Fetch.post(API_URL.manhour.queryNeedCheckList, {
            offset: current,
            limit: pageSize,
            ...params,
            stageIds: (stageIds || []).join(','),
        }).then(res => {
            const { datas, totalCount } = res;
            pagination.total = totalCount;
            this.setState({
                data: datas,
                pagination,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            curParams: { ...searchParams },
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { curParams } = this.state;
        const { stageIds } = curParams;
        const params = this.splitParams(curParams);
        const url = API_URL.manhour.exportNeedCheckList;
        ExportUtil.export({ ...params, stageIds: (stageIds || []).join(',') }, null, url);
    }

    confirmDirectly = record => {
        Modal.confirm({
            iconType: 'exclamation-circle',
			title: <div style={{ marginLeft: 42 }}>确认此项目在该月的未确认工时无需继续确认？</div>,
			content: '标记为无需继续确认，那么该月的未确认工时项目清单中，不再显示此项目',
            onOk: () => {
                const { yearNum, monthNum, investigationId } = record;
				Fetch.post(API_URL.manhour.setNotNeedCheck, {
                    yearNum,
                    monthNum,
                    investigationId,
                }).then(res => {
                    const { success } = res;
                    message.success(success);
                    this.loadData();
                }).catch(err => {
                    console.error(err);
                });
            }
        });
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    getColumns = () => {
        const columns = [{
            title: '时间',
            dataIndex: 'date',
            key: 'date',
            fixed: 'left',
            width: 80,
            render: (text, record) => {
                const { yearNum, monthNum } = record;
                return format('month', yearNum, monthNum);
            },
        }, {
            title: '项目编号',
            dataIndex: 'investigationCode',
            key: 'investigationCode',
            width: 100,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 180,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 80,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineNames',
            key: 'secondLineNames',
            width: 100,
        }, {
            title: '项目阶段',
            dataIndex: 'investigationStageNames',
            key: 'investigationStageNames',
            width: 120,
        }, {
            title: '项目经理',
            dataIndex: 'pmName',
            key: 'pmName',
            width: 80,
        }, {
            title: '项目经理工号',
            dataIndex: 'pmCode',
            key: 'pmCode',
            width: 80,
        }, {
            title: '项目经理主管',
            dataIndex: 'pmLeaderName',
            key: 'pmLeaderName',
            width: 80,
        }, {
            title: '项目经理主管工号',
            dataIndex: 'pmLeaderCode',
            key: 'pmLeaderCode',
            width: 80,
        }, {
            title: '未确认工时/FTE',
            dataIndex: 'fte',
            key: 'fte',
            width: 80,
            render: (text, record) => {
                const { fte, manHour } = record;
                return (
                    <a onClick={() => this.showDetail(record)}>{(manHour || 0).toFixed(2)}h/{fte}</a>
                );
            },
        }, {
            title: '未确认标准访视数',
            dataIndex: 'visitStandardAmount',
            key: 'visitStandardAmount',
            width: 80,
        }, {
            title: '操作',
            key: 'operation',
            fixed: 'right',
            width: 100,
            render: (text, record) => {
                const { canSetNoConfirm } = record;
                return canSetNoConfirm ? <a onClick={() => this.confirmDirectly(record)}>无需继续确认</a> : '-';
            },
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    showDetail = (record) => {
        this.detailRef.show(record);
    }

    render() {
        const { data, loading, pagination, maxMonth, searchParams, stageOption, businessList } = this.state;
        return (
            <div className="content">
                <SideNav selectKey="unconfirmProManhour" />
                <div className="main">
                    <div className="main-content">
                        <Filter
                            search={this.search}
                            maxMonth={maxMonth}
                            params={searchParams}
                            stageOption={stageOption}
                            businessList={businessList}
                            onChange={this.handleFilterChange}
                            buttons={[
                                <Button key="export" type="primary" onClick={this.export}>导出</Button>
                            ]}
                        />
                        <TableC
                            data={data}
                            scrollY={500}
                            loading={loading}
                            columns={this.getColumns()}
                            pagination={pagination}
                            onChange={this.handleTableChange}
                        />
                        <UnconfrimManhourSummary ref={el => this.detailRef = el} loadData={this.loadData} />
                    </div>
                </div>
            </div>
        );
    }
}

export default UnconfirmProManhour;


// WEBPACK FOOTER //
// ./src/components/manHour/unconfirmProManhour/index.js